export default {
  checkOverflow (element) {
    return (element.offsetHeight + 20) < element.scrollHeight
  },
  getSpanRepeat (array, key) {
    if (!array) {
      return ''
    }
    let resultString = ''

    for (let i = 0; i < array.length; i++) {
      if (i !== 0) {
        resultString += ', '
      }
      const split = key.split('.')
      let nestedValue = array[i][split[0]]
      for (let i = 1; i < split.length; i++) {
        nestedValue = nestedValue[split[i]]
      }

      resultString += `<span>${nestedValue}</span>`
    }

    return resultString
  }
}
